import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import styles from './ClanLeagueSignInline.module.scss.js';

var ClanLeagueSignInline = (function (_super) {
    __extends(ClanLeagueSignInline, _super);
    function ClanLeagueSignInline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClanLeagueSignInline.prototype.render = function () {
        return (React.createElement("div", { className: classNames(styles.container, this.props.className), style: { borderColor: this.props.color } }, this.props.title));
    };
    return ClanLeagueSignInline;
}(React.PureComponent));

export { ClanLeagueSignInline as default };
//# sourceMappingURL=ClanLeagueSignInline.js.map
